export default "__VITE_ASSET__L6y0f0f9__"